export enum WorkingHoursStatusEnum {
	CLOSED,
	OPEN,
}
